import { Component, Inject, inject, Input, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RestService } from 'src/app/services/RestService';




@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
})
export class ForgotPasswordComponent {

    @Input() login: string;
    public isValidated = false;

    public emailSentTo: boolean = false;
    public isAtLeastMedium!: boolean;


    constructor(
        @Inject(RestService) private restService: RestService,
        private router: Router,
    ) {

        inject(BreakpointObserver)
        .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
        .pipe()
        .subscribe((result) => {
            const matches = result.matches;
            this.isAtLeastMedium = matches;
        });

    }

    public onSubmit(): void {
        this.passwordInit();
    }

    public async passwordInit() {

    }

    async validate(): Promise<void> {
        const data = { login: this.login };

        try {
            await this.restService.resetPassword(data);
        } catch (error) {
            console.error('Error during validation:', error);
        } finally {
            this.emailSentTo = true;
            this.isValidated = true;
        }
    }


    public send(): void {
        this.passwordInit();
        this.router.navigate(['/forgot-password']);
    }
}
